/**
 * Utility functions for TwoPoint Widget
 */

/**
 * Generate unique widget ID using crypto.randomUUID() with fallback
 */
export const generateUniqueId = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `twopoint-${crypto.randomUUID()}`;
  }
  // Fallback: timestamp + random
  return `twopoint-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Default CSS styles for TwoPoint iframes
 */
export const getDefaultStyles = (): string => {
  return `
.twopoint-iframe {
  width: 100%;
  border: none;
  display: block;
  min-height: 400px;
  transition: height 0.3s ease-out;
}

.twopoint-iframe-wrap {
  margin: 0;
  padding: 0;
}
`.trim();
};

/**
 * Inject CSS into document head
 */
export const injectStyles = (css: string): void => {
  const styleId = 'twopoint-widget-styles';

  // Don't inject if already present
  if (document.getElementById(styleId)) {
    return;
  }

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = css;
  document.head.appendChild(style);
};

/**
 * Log message if debug mode is enabled
 */
export const debugLog = (debugMode: boolean, ...args: unknown[]): void => {
  if (debugMode) {
    console.log('[TwoPoint Widget]', ...args);
  }
};
